export default __webpack_public_path__ + "static/media/get_financial_assistance_banner.2b04eb4e.jpg";